module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('h1', [_vm._v("About the images annotator")]), _c('p', [_vm._v("This app provides a simple way to label or comment a series of pictures .")]), _c('p', [_vm._v("It was developed at the Ediburgh Genome Foundry as a useful toy project for Vue.js")]), _c('p')])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7e50da6c!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/About.vue
// module id = 21
// module chunks = 1